class ClEnrollmentCta extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.trigger = this.querySelector('[data-enrollment-cta-trigger]');
    this.trigger?.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.trigger?.removeEventListener('click', this.handleClick);
  }

  get action() {
    return this.dataset.enrollmentAction || 'course_finder';
  }

  get productId() {
    return this.trigger?.dataset.productId || this.dataset.productId || '';
  }

  get modalidadeRequired() {
    const value = this.trigger?.dataset.modalidadeRequired || this.dataset.modalidadeRequired;
    return value === 'true';
  }

  get disabled() {
    return Boolean(this.trigger?.disabled || this.trigger?.getAttribute('aria-disabled') === 'true');
  }

  buildEventDetail() {
    return {
      action: this.action,
      productId: this.productId,
      modalidadeRequired: this.modalidadeRequired,
      trigger: this.trigger,
      component: this,
    };
  }

  dispatchActionEvent(name, detail, cancelable = false) {
    return this.dispatchEvent(
      new CustomEvent(name, {
        bubbles: true,
        cancelable,
        detail,
      })
    );
  }

  openCourseFinder() {
    if (typeof window.abrirCourseFinder !== 'function') return false;

    window.abrirCourseFinder();
    return true;
  }

  openDirectEnrollment(productId) {
    const options = this.dataset.skipInlineValidation === 'true' ? { skipInlineValidation: true } : {};
    if (window.EnrollPopupRegistry && typeof window.EnrollPopupRegistry.open === 'function') {
      window.EnrollPopupRegistry.open(productId || undefined, options);
      return true;
    }

    if (typeof window.abrirPopupMatricula === 'function') {
      window.abrirPopupMatricula(productId || undefined, options);
      return true;
    }

    return false;
  }

  handleClick(event) {
    if (this.disabled) {
      event.preventDefault();
      return;
    }

    const detail = this.buildEventDetail();
    const canContinue = this.dispatchActionEvent('cl:enrollment-cta:before-action', detail, true);

    if (!canContinue) {
      event.preventDefault();
      return;
    }

    let actionHandled = false;

    if (detail.action === 'course_finder') {
      actionHandled = this.openCourseFinder();
    } else if (detail.action === 'direct_enroll') {
      actionHandled = this.openDirectEnrollment(detail.productId);
    }

    if (!actionHandled) return;

    event.preventDefault();
    event.stopPropagation();
    this.dispatchActionEvent('cl:enrollment-cta:after-action', detail);
  }
}

if (!customElements.get('cl-enrollment-cta')) {
  customElements.define('cl-enrollment-cta', ClEnrollmentCta);
}
